module.exports = __webpack_public_path__ + "static/media/2.cfa31455.jpg";